import React from "react";

const NotFound = () => {
  return (
    <>
      <h1>Seite ungueltig</h1>
    </>
  );
};

export default NotFound;
